export default {"src":"/_next/static/media/dialogs-simple.7fc32000.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};